export const WAREHOUSE_TYPE = {
  MAIN: "main",
  WARRANTY: "warranty",
} as const;

export const WAREHOUSE_TYPE_OPTIONS = [
  { value: WAREHOUSE_TYPE.MAIN, label: "Kho chính (Main)" },
  { value: WAREHOUSE_TYPE.WARRANTY, label: "Kho bảo hành (Warranty)" },
];
